import { render, staticRenderFns } from "./FundsList.vue?vue&type=template&id=5aced504&"
import script from "./FundsList.vue?vue&type=script&lang=js&"
export * from "./FundsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports